import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { Section, Field, NativeSelect } from "@/components/common";

/** Unit for custom size inputs only (quote custom size, machine custom max size, new material sizes). Named sizes never change. */
export function SizeUomSetting({ canEdit }) {
  const { user, refresh } = useAuth();
  const [v, setV] = useState(user?.tenant?.size_uom || "in");
  const [lf, setLf] = useState(user?.tenant?.lf_uom || "sqft");
  const saveLf = async (next) => {
    setLf(next);
    try { await api.put("/tenant/lf-uom", { lf_uom: next }); await refresh(); toast.success(`Large format now uses ${next}`); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const save = async (next) => {
    setV(next);
    try { await api.put("/tenant/size-uom", { size_uom: next }); toast.success(`Custom sizes now use ${next === "in" ? "inches" : "mm"}`); setTimeout(() => window.location.reload(), 600); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Section title="Custom size unit" testId="size-uom-section">
      <div className="p-5"><Field label="Unit for custom width × height inputs"><NativeSelect testId="size-uom-select" disabled={!canEdit} value={v} onChange={save} options={[{ value: "in", label: "Inches (default)" }, { value: "mm", label: "Millimetres (mm)" }]} /></Field>
        <p className="mt-2 text-xs text-slate-500">Applies only when "Custom" size is chosen: quote finished size, machine max sheet size and new material sizes. Standard sizes (A4, A3, SRA3, 30×40in) are unchanged.</p>
        <div className="mt-4"><Field label="Large format area unit"><NativeSelect testId="lf-uom-select" disabled={!canEdit} value={lf} onChange={saveLf} options={[{ value: "sqft", label: "Square feet (sqft, default)" }, { value: "sqm", label: "Square metres (sqm)" }, { value: "sqyd", label: "Square yards (sqyd)" }]} /></Field>
        <p className="mt-2 text-xs text-slate-500">Large format job types and machines only: quote lines show area and rates in this unit. Roll label, flexo and label jobs are unaffected.</p></div></div>
    </Section>
  );
}
